import { CREATE_ITEM, GET_ITEM, ITEM_REQUEST,DELETE_ITEM, UPDATE_ITEM, ITEM_REQUEST_FAILURE, GET_ITEMS_PAGE } from "../types";

const initialState = {
    items: [],
    itemsPage: [],
    page: 1,
    pageSize: 10,
    search: '',
    where: {},
    total: 0,
    loading: false,
    error: null,
  };

const itemReducer = (state = initialState, action) => {
  switch (action.type) {
    case ITEM_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_ITEMS_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        itemsPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case GET_ITEM: {
      return {
        ...state,
        items: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_ITEM:
      return {
        ...state,
        items: [action.payload, ...state.items],
        loading: false,
        error: null
      };
    case UPDATE_ITEM:
      const itemsData = state.items.slice(0);
      const uIndex = itemsData.findIndex((data) => data.id === action.payload.id);
      itemsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        items: [ ...itemsData ],
        loading: false,
        error: null
      };
    case DELETE_ITEM:
      const items = state.items?.slice(0);
      const index = items.findIndex((data) => data.id === action.id);
      if (index > -1) {
          items.splice(index, 1);
      }
      return {
        ...state,
        items: [...items],
        loading: false,
        error: null
      }
    case ITEM_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default itemReducer
